import type { ReactNode } from 'react';

/** The 11 semantic status aliases from the 5 Axis design system. */
export type StatusAlias =
  | 'pending'
  | 'in-progress'
  | 'staged'
  | 'in-transit'
  | 'success'
  | 'delivered'
  | 'error'
  | 'attention'
  | 'partial'
  | 'transit-alt'
  | 'neutral';

export const StatusPill = ({ tone, children }: { tone: StatusAlias; children: ReactNode }) => (
  <span className={`p-status-pill p-status-pill--${tone}`}>{children}</span>
);
